<template>
  <modal
    :show="isModalVisible"
    @close="isModalVisible = false"
    class="prompt-modal"
    :containerStyle="`background:#EFF3F3; padding: 2.8125rem; max-width:900px; ${
      isPaymentComplete ? '' : 'width:900px; height:650px'
    }`"
  >
    <div class="d-flex align-items-stretch h-100">
      <template v-if="!isPaymentComplete">
        <div class="flex-1 d-flex align-items-center flex-column" style="margin-right: 1.75rem">
          <div class="my-auto">
            <div class="modal-header flex-column">
              <h2 class="m-0" style="font-size: 1.75rem; line-height: 2.25rem">
                Why you should upgrade to Refera Premium?
              </h2>
              <p class="m-0 my-2 font-weight-bold" style="width: 95%; font-size: 1rem">
                Boost your referrals with these premium features:
              </p>
            </div>
            <div class="modal-body d-flex pb-0">
              <div>
                <div class="feature-list pb-3 pt-1" v-if="selectedPlan">
                  <div
                    v-for="feature in selectedPlan.features"
                    class="d-flex align-items-center mb-3"
                    :key="feature.name"
                  >
                    <div class="feature-list-icon bg-white rounded mr-3" style="padding: 0.625rem">
                      <img :src="feature.icon" />
                    </div>
                    <div class="flex-grow-1">
                      <b class="feature-line">{{ feature.name }}</b>
                      <span class="text-muted feature-line">{{ feature.info }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-white rounded p-3" style="margin-left: 1.75rem; width: 420px">
          <div class="payment p-3 text-center">
            <h4 style="font-size: 1.3125rem">Become a premium practice</h4>
            <p class="m-0 my-2 text-muted" style="width: 95%">Upgrade now to get all the features of premium.</p>
            <div class="plans mt-3">
              <div
                v-for="plan in plans"
                :key="plan.name"
                class="plan align-items-center justify-content-between mb-2 px-3 py-2 rounded d-flex"
                style="background-color: #f8f9f9"
              >
                <div class="form-check">
                  <input
                    v-model="selectedPlanId"
                    class="form-check-input"
                    type="radio"
                    :id="`billingPlan${plan.name}`"
                    :value="plan.id"
                    :checked="selectedPlanId == plan.id"
                    :disabled="plan.isCurrent"
                  />
                  <label class="form-check-label" :for="`billingPlan${plan.name}`">
                    <b style="font-size: 1rem"> {{ plan.name }}</b> </label
                  ><span v-if="plan.isCurrent" class="badge badge-light text-primary ml-1 align-self-start"
                    >current plan</span
                  >
                </div>
                <div class="price">
                  <b style="font-size: 1.25rem">${{ plan.amount && plan.amount.toLocaleString() }}</b>
                  <small class="text-muted">/{{ plan.term }}</small>
                </div>
              </div>
            </div>
            <hr style="border-top: 1px solid #cbd9d9" />
            <div class="text-left mb-3 pl-1">
              <h6 style="letter-spacing: 0">Billing information</h6>
            </div>
            <card-payment
              v-if="selectedPlanId"
              @complete="isPaymentComplete = true"
              :ctaText="ctaText"
              :planId="selectedPlanId"
            />
            <div class="modal-footer">
              <a
                href="javascript:void(0)"
                @click="isModalVisible = false"
                class="btn btn-block btn-link text-primary btn-lg mt-2 font-weight-bolder"
                id="premiumNotInterested"
                >I'm not interested</a
              >
            </div>
            <span class="text-muted mt-3 d-block">No contract necessary. Cancel anytime.</span>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="h-100 text-center align-items-center d-flex">
          <div class="">
            <img src="@/assets/svg/logo.svg" height="50" class="mb-3" />
            <h2 class="m-0" style="font-size: 1.75rem; line-height: 2.25rem">Welcome to Refera Premium!</h2>
            <p class="m-0 my-2" style="width: 95%; font-size: 1rem; font-weight: 500">
              Now you can enjoy the all the benefits of Refera Premium.
            </p>
            <a
              href="javascript:void(0)"
              @click="isModalVisible = false"
              class="btn btn-block btn-link text-primary btn-lg mt-3 font-weight-bolder"
              >Close</a
            >
          </div>
        </div>
      </template>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
import { mapState, mapGetters } from 'vuex'
import CardPayment from '@/components/billing/CardPayment.vue'
export default {
  components: { Modal, CardPayment },
  data() {
    return {
      isSubmitting: false,
      isPaymentComplete: false,
      selectedPlanId: null,
    }
  },
  async mounted() {
    try {
      if (!this.plans?.length) await this.$store.dispatch('billing/load')
      this.selectedPlanId = this.plans[0].id
    } catch (err) {
      console.error(err)
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('settings', ['isPaymentModalVisible']),
    ...mapState('billing', ['isLoadingPlans']),
    ...mapGetters('billing', ['plans']),
    selectedPlan() {
      return this.plans?.filter((s) => s.id == this.selectedPlanId)?.[0]
    },
    isModalVisible: {
      get() {
        return this.isPaymentModalVisible
      },
      set(value) {
        this.$store.dispatch('settings/setIsPaymentModalVisible', value)
      },
    },
    ctaText() {
      return this.selectedPlan?.trial_period_days
        ? `Start free ${this.selectedPlan.trial_period_days} day trial`
        : 'Upgrade now'
    },
  },
}
</script>
<style lang="scss" scoped>
.feature-line {
  line-height: 1.3125rem;
  display: block;
}
.feature-list-icon img {
  max-width: 30px;
  min-width: 30px;
  width: 30px;
}
.modal-footer > * {
  margin: 0;
}
</style>
